<template>
  <div>
    <div class="page-title mb-30">Monitoring</div>
    <div class="page-content">
      <el-table border size="small" :data="data" v-loading="loading">
        <el-table-column label="Metric" prop="metric"> </el-table-column>
        <el-table-column label="Statistics" prop="statistics">
          <template slot-scope="scope">
            {{ scope.row.statistics }} {{ scope.row.suffix }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { secondFormat } from '../../../utils/utils'
import swal from 'sweetalert'
import ApiService from '@/services/CommonApiService.js'
export default {
  data() {
    return {
      loading: false,
      data: [
        {
          metric: 'Pods Pass Rate (Quality)',
          statistics: '',
          suffix: '(98/100 last 30 days)'
        },
        {
          metric: 'Pods Testing Time (Efficiency)',
          statistics: '',
          suffix: '(avg. last 30 days)'
        }
      ]
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      ApiService.GetMonitoring()
        .then(response => {
          this.loading = false
          if (response.data.success) {
            let data = response.data.data
            if (data.quality) {
              this.data[0].statistics = data.quality + '%'
              this.data[0].suffix = '(' + data.quality + '/100 last 30 days)'
            }
            if (data.efficieny) {
              if (typeof data.efficieny === 'number') {
                let efficieny = secondFormat(data.efficieny)
                let efficienyStr = ''
                if (efficieny[0]) efficienyStr += efficieny[0] + 'd'
                if (efficieny[1]) efficienyStr += efficieny[1] + 'h'
                if (efficieny[2]) efficienyStr += efficieny[2] + 'm'
                if (efficieny[3]) efficienyStr += efficieny[3] + 's'
                this.data[1].statistics = efficienyStr
              }
            }
          } else {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
